module.exports = __webpack_public_path__ + "a4e5bacfb8739c50ff8885a40189ae35.png";